import React, { useState } from "react";
import logo from "../../../assets/images/others/host-side-images/logo.png";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import { ROLES } from "utils/helpers/enums/roles.enum";
import useUtils from "hooks/useUtils";

const LoginType: React.FC = () => {
  const navigate = useNavigate();
  const { createQuery } = useUtils();

  const handleNavigate = (role: ROLES) => {
    const query = createQuery({ role });
    navigate(siteRoutes.signUp + query);
  };

  const goToAmbassadorRole = () => {
    navigate(siteRoutes.ambassadorRole);
  };

  return (
    <div className="w-full h-screen flex flex-col p-4 sm:p-6 lg:px-8 xl:px-10 lg:py-6">
      <div className="flex justify-center my-6">
        <img src={logo} alt="logo" className="h-20" />
      </div>
      <div className="flex-1 flex  justify-center">
        <div className=" w-full">
          <h1 className="text-start text-3xl font-medium text-blackie">
            Continue as
          </h1>
          <div className="flex flex-col gap-4 w-full mt-3">
            <button
              onClick={() => handleNavigate(ROLES.ATTENDEE)}
              className="w-full lg:h-[64px] border border-borderColor hover:border rounded-full p-3 text-blackie text-xl hover:bg-blueBg hover:text-blueText transition-all duration-300 ease-in-out"
            >
              Attendee
            </button>
            <button
              onClick={() => handleNavigate(ROLES.HOST)}
              className="w-full lg:h-[64px] border border-borderColor hover:border rounded-full p-3 text-blackie text-xl hover:bg-yellowBg hover:text-yellowText transition-all duration-300 ease-in-out"
            >
              Host
            </button>
            <button
              onClick={goToAmbassadorRole}
              className="w-full lg:h-[64px] border border-borderColor hover:border rounded-full p-3 text-blackie text-xl hover:bg-purpleBg hover:text-purpleText transition-all duration-300 ease-in-out"
            >
              Ambassador
            </button>
          </div>
          <div className="text-center mt-4">
            <p className="text-blackie text-base">
              Already have an Account?
              <span
                onClick={() => {
                  navigate(siteRoutes.login);
                }}
                className="text-yellowText cursor-pointer ml-[3.5px]"
              >
                Sign in
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginType;
